const getSpeeds = () => {
  const speedRaw = window.localStorage.getItem('speeds')

  return speedRaw ?
    JSON.parse(window.localStorage.getItem('speeds')) :
    {flat: 5.0, up: 400, down: 1000}
}

const getHoursOfWalk = (speeds, distance, up, down) => {
  return distance / 1000 / speeds.flat + up / speeds.up + down / speeds.down
}

const displayTime = (hours) => `${Math.floor(hours)}h ${Math.round(hours * 60 % 60)} min`

export { getSpeeds, getHoursOfWalk, displayTime }